module.exports = __webpack_public_path__ + "static/media/time-off-request.86d7c8bb.png";